import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Seo = ({ courses = [] }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t("seo.title");
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t("seo.description"));
    document.documentElement.lang = i18n.language;

    const ld = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: "Kursos Online",
          url: "https://kursosonline.com",
          logo: "https://kursosonline.com/og-image.png",
        },
        {
          "@type": "WebSite",
          name: "Kursos Online",
          url: "https://kursosonline.com",
        },
        {
          "@type": "ItemList",
          itemListElement: courses.slice(0, 40).map((c, i) => ({
            "@type": "ListItem",
            position: i + 1,
            item: {
              "@type": "Course",
              name: c.title,
              description: c.subtitle || c.description || "",
              url: `https://kursosonline.com/curso/${c.id}`,
              provider: { "@type": "Organization", name: "Kursos Online" },
              offers: { "@type": "Offer", price: c.price, priceCurrency: "USD" },
            },
          })),
        },
      ],
    };
    let script = document.getElementById("jsonld-courses");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "jsonld-courses";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(ld);
  }, [t, i18n.language, courses]);

  return null;
};

export default Seo;
